import { useCallback, useState } from 'react'
import { Editor, Range, Element as SlateElement, Node as SlateNode } from 'slate'
import { useSlate } from 'slate-react'

import { Button } from 'core-components/library/button'
import { ModalDialog } from 'core-components/library/modalDialog'
import { insertSeparator } from 'core-components/library/richTextEditor/helpers/slateHelper'
import {
  BLOCK_FORMATS,
  CustomEditor,
} from 'core-components/library/richTextEditor/interface/custom-types'
import { TOOLBAR_BUTTONS } from 'core-components/library/richTextEditor/interface/IToolbar'
import { TSeparator } from 'core-components/library/richTextEditor/interface/TSeparator'

import { TOOLBAR_TITLES } from '../../constants'

import { SeparatorSettingsDialog } from './SeparatorSettingsDialog'

interface IProps {
  disabled: boolean
  className?: string
}

const getLink = (editor: CustomEditor, node?: SlateNode) => {
  if (node) {
    const link: TSeparator = {
      text: SlateNode.string(node),
      backgroundColor: node['backgroundColor'],
      height: node['height'],
      width: node['width'],
      alignment: node['alignment'],
    }
    return link
  }

  const emptyLink: TSeparator = {
    text: '',
    backgroundColor: 'var(--color-primary-main)',
    height: '3px',
    width: '100%',
    alignment: 'center',
  }
  const { selection } = editor

  if (!selection || (selection && Range.isCollapsed(selection))) {
    return emptyLink
  }
  return emptyLink
}

export const SeparatorButton = (props: IProps) => {
  const [headerVisible, setHeaderVisible] = useState(false)
  const [separator, setSeparator] = useState<TSeparator>({
    text: '',
    backgroundColor: 'var(--color-primary-main)',
    height: '3px',
    width: '100%',
    alignment: 'center',
  })

  const editor = useSlate()

  const [activeElement] = Editor.nodes(editor, {
    match: (n) =>
      !Editor.isEditor(n) && SlateElement.isElement(n) && n.type === BLOCK_FORMATS.separator,
  })

  const addSeparator = (settings: TSeparator) => {
    insertSeparator(editor, settings)
    onClose()
  }

  const onClose = useCallback(() => {
    setHeaderVisible(false)
  }, [])

  return (
    <>
      <Button
        className={props.className}
        onClick={() => {
          if (activeElement) {
            setSeparator(getLink(editor, activeElement[0]))
          } else {
            setSeparator(getLink(editor))
          }
          setHeaderVisible(true)
        }}
        disabled={props.disabled}
        title={TOOLBAR_TITLES[TOOLBAR_BUTTONS.Separator]}
        color={'grey'}
        variant={'text'}
        iconButton={'kbase kbase-separator'}
      />
      <ModalDialog
        title={'Separator Settings'}
        content={SeparatorSettingsDialog}
        contentProps={{
          separatorSettings: separator,
          onSave: (settings: TSeparator) => {
            addSeparator(settings)
          },
          onCancel: () => onClose(),
        }}
        size={'auto'}
        onClose={onClose}
        show={headerVisible}
      />
    </>
  )
}
